export function htmlHasText(html?: string | null): boolean {
  return Boolean(
    String(html || "")
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/gi, " ")
      .trim(),
  );
}
